import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Input, FormField } from '../../components/ui/Input';
import { authApi } from '../../api/auth';
import { ApiError } from '../../api/client';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authApi.requestPasswordReset(email);
      setSubmitted(true);
    } catch (err) {
      // The backend may return success even if email isn't found (anti-enumeration),
      // but show any actual error to the user.
      const msg = err instanceof ApiError ? err.message : 'Something went wrong';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="w-full max-w-md relative !p-8">
      <div className="text-center mb-8">
        <Link to="/" className="font-display font-bold text-2xl text-gradient">
          AltCoinsMoney
        </Link>
        <h1 className="font-display text-3xl font-bold mt-6">Reset password</h1>
        <p className="text-ink-600 text-sm mt-2">
          {submitted
            ? 'Check your inbox for the reset link'
            : "Enter your email and we'll send you a reset link"}
        </p>
      </div>

      {!submitted ? (
        <form onSubmit={handleSubmit} className="space-y-4">
          <FormField label="Email" htmlFor="email">
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </FormField>

          {error && (
            <div className="p-3 rounded-2xl bg-danger/5 border border-danger/20 text-danger text-sm">
              {error}
            </div>
          )}

          <Button type="submit" isLoading={loading} className="w-full">
            Send reset link
          </Button>
        </form>
      ) : (
        <div className="p-4 rounded-2xl bg-success/5 border border-success/20 text-ink-700 text-sm">
          If an account exists for <span className="font-mono">{email}</span>, a reset link
          has been sent. The link expires in 1 hour.
        </div>
      )}

      <div className="mt-6 text-center text-sm text-ink-600">
        <Link to="/auth/login" className="text-violet-600 hover:underline">
          Back to sign in
        </Link>
      </div>
    </Card>
  );
}
